import { select, take } from 'redux-saga/effects';

import type { User } from '../domain/user';

import { UserActionTypes, userSelector } from '../redux/ui/user';

/**
 * お気に入り適用で kyoyuGroupCode を参照する前に呼ぶ。
 * `fav_id` 直リンク等で、お気に入り一覧取得が SET_USER より先に完了すると
 * `userSelector` が未設定のままサニタイズがスキップされるため、ユーザー確定を待つ。
 */
export function* ensureUserLoadedForSaga(): Generator<
  unknown,
  User | undefined,
  User | undefined
> {
  const user = yield select(userSelector);
  if (user?.userId != null) {
    return user;
  }
  yield take(UserActionTypes.SET_USER);
  const userAfterSet = yield select(userSelector);
  return userAfterSet;
}
